'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import integrations from '../../../utils/integrations';
import { getEventValue } from '../../../utils/jsEventUtils';
import { useControlsContext } from '../context';
import { THIRD_PARTY_APP_CHANNEL, THIRD_PARTY_APP_USER } from '../shareTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const COMMON_I18N_KEYS = {
  user: 'reporting-action-components.actions.shareVia.dialog.form.shareToChannelOrUserOptions.user',
  channel: 'reporting-action-components.actions.shareVia.dialog.form.shareToChannelOrUserOptions.channel',
  optionGroupLabel: 'reporting-action-components.actions.shareVia.dialog.form.shareToChannelOrUserOptions.optionGroupLabel'
};
const GOOGLE_CHAT_I18N_KEYS = Object.assign({}, COMMON_I18N_KEYS, {
  channel: 'reporting-action-components.actions.shareVia.dialog.form.shareToChannelOrUserOptions.space',
  optionGroupLabel: 'reporting-action-components.actions.shareVia.dialog.form.shareToChannelOrUserOptions.spaceOptionGroupLabel'
});
const getI18nKeys = appId => integrations.isGoogleChatAppId(appId) ? GOOGLE_CHAT_I18N_KEYS : COMMON_I18N_KEYS;
const ShareToSlackChannelOrUserOptions = () => {
  const {
    thirdPartyAppShareOptionType,
    setThirdPartyAppShareOptionType,
    setThirdPartyAppShareOptionSelection,
    thirdPartyApp
  } = useControlsContext();
  const i18nKeys = getI18nKeys(thirdPartyApp === null || thirdPartyApp === void 0 ? void 0 : thirdPartyApp.id);
  const onChange = e => {
    setThirdPartyAppShareOptionType(getEventValue(e));
    setThirdPartyAppShareOptionSelection({});
  };
  return /*#__PURE__*/_jsx(FormControl, {
    marginBlockEnd: "300",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKeys.optionGroupLabel,
      options: {
        appName: thirdPartyApp === null || thirdPartyApp === void 0 ? void 0 : thirdPartyApp.name
      }
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "shareSlackType",
      children: [/*#__PURE__*/_jsx(RadioInput, {
        checked: thirdPartyAppShareOptionType === THIRD_PARTY_APP_CHANNEL,
        value: THIRD_PARTY_APP_CHANNEL,
        onChange: e => onChange(e),
        "data-test-id": 'slack-channel-radio-select',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKeys.channel,
          options: {
            appName: thirdPartyApp === null || thirdPartyApp === void 0 ? void 0 : thirdPartyApp.name
          }
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        checked: thirdPartyAppShareOptionType === THIRD_PARTY_APP_USER,
        value: THIRD_PARTY_APP_USER,
        onChange: e => onChange(e),
        "data-test-id": 'slack-user-radio-select',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKeys.user
        })
      })]
    })
  });
};
export default ShareToSlackChannelOrUserOptions;